// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"sr_a bhh_a bhh_r bhh_j","Photos__img":"sr_b bhh_b"};